
import { mergeMap } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FileService } from '../../services/file.service';
import { NotificationService } from '../../services/notification.service';
import { MessageService } from '../../services/message.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { UserService } from "../../services/user.service";
import { FileTableService } from "../../services/filetable.service";
import { ContractorService } from '../../services/contractor.service';
import { PIDService } from '../../services/pid.service';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from "@angular/forms";

import { NgxGalleryOptions } from '@kolkov/ngx-gallery';
import { NgxGalleryImage } from '@kolkov/ngx-gallery';
import { NgxGalleryAnimation } from '@kolkov/ngx-gallery';
import { NgxGalleryComponent } from '@kolkov/ngx-gallery';

import { pagix, PagixReturn } from 'pagix'

let moment = require('moment');


@Component({
  selector: 'file-details',
  templateUrl: './file-details.component.html',
  styleUrls: ['./file-details.component.scss']
})
export class FileDetailsComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('modalEditFile') modalEditFile;
  @ViewChild(NgxGalleryComponent) gallery: NgxGalleryComponent;

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  paginate: PagixReturn;

  error = null;
  steps = [];
  allContractors = [];
  filteredContractors;

  file = {
    PID: null,
    _id: null,
    readOnly: null,
    locked: null,
    sharingType: null,
    sharing: [],
    versions: [],
    allVersions: [],
    contractor: {
      email: null,
      name: null
    }
  };

  fileViewUrls = null;
  fileDetails = null;
  messages = [];
  fileLinkStats = {};
  openMessages = false;
  linkEmail = '';
  selectedIndex = 0;
  previewIndex = null;

  modal = {
    editFile: false,
    linkFile: false,
    deleteFile: false,
    file: null,
    version: null
  };

  originPIDId = null;
  originPID = null;
  versionId = null;

  private _defaultFile = {
    name: '',
    job: '',
    type: '',
    description: '',
    contractor: {
      name: '',
      phone: '',
      email: ''
    },
    PID: {
      address: {
        address: '',
        zip: '',
        city: '',
        country: ''
      }
    }
  };
  contractorControl: FormControl = new FormControl();

  private _sub;
  isPhone = false;

  stringify(data) {
    return JSON.stringify(data);
  }

  constructor(private _route: ActivatedRoute, private _fileService: FileService,
    private _router: Router, private _contractorService: ContractorService,
    private _notification: NotificationService, private _sanitizer: DomSanitizer,
    public translate: TranslateService, private _messageService: MessageService,
    private _user: UserService, private datePipe: DatePipe, private _pidService: PIDService,
    private _filetable: FileTableService) {
    this.steps.push({ name: ['Proprieties'], ref: [''] })
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  private _setSteps(file) {
    this.steps = [{ name: ['Proprieties'], ref: [''] }];
    this.steps.push({
      name: ["DATA.PID", ": ", file.PID.name],
      ref: ['pid', file.PID._id]
    });

    if (this.originPID) {
      this.steps.push({
        name: ["DATA.PID", ": ", this.originPID.name],
        ref: ['pid', this.originPIDId]
      });
    }
    this.steps.push({
      name: ['DATA.FILE', ": ", file.name],
      ref: ['file', file._id]
    });
  }


  goToFileVersionDetails(id) {
    this._router.navigate(['file', this.file._id, this.originPIDId, id]);
  }

  getHeight() {
    if (this.isPhone) return 92;
    return 66;
  }

  getHeaderHeight() {
    if (this.isPhone) return 0;
    return 50;
  }

  getWidth() {
    if (this.isPhone) {
      return 287;
    }
    return 185;
  }

  getSafeUrl(url) {
    let res = this._sanitizer.bypassSecurityTrustResourceUrl(url);
    //console.log("safe url", res);
    return res;
  }

  ngAfterViewInit() {
    //console.log("ngAfterViewInit");
    //noinspection TypeScriptValidateTypes

    this._contractorService.getMine()
      .subscribe(
        (contractors: any) => {
          contractors = contractors.filter(x => !x.shared).filter(x => !x.hidden).sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
          });
          this.allContractors = contractors;
          this.filteredContractors = this.contractorControl.valueChanges.pipe(
            startWith(null),
            map((val: string) => val && val.length >= 1 ? this.contractorAutocompleteFilter(this.allContractors, val) : this.allContractors.slice(0, 0)));
        });

    this._sub = this._route.params.pipe(
      mergeMap(params => {
        this.originPIDId = params['pid'];
        this.versionId = params['version'];
        return this._fileService.getFileInformation(params['id'], params['pid'])
      }))
      .subscribe(
        (file: any) => {
          //console.log("set steps, file version(s) 1", file.version);

          if (this.originPIDId != file.PID._id) {
            this._pidService.get(this.originPIDId).subscribe(p => {
              //console.log("originating pid", p);
              this.originPID = p;
              this._setSteps(file);
            });
          } else {
            this.originPID = null;
            this._setSteps(file);
          }

          this.file = _.mergeWith(this._defaultFile, file, (obj, src) => { if (obj && !src) { return obj; } });
          this.file.PID.children = { display: this.file.PID.children, all: this.file.PID.children };

          //console.log("file details. editable:", this.fileIsEditable(), "allowed:", this.userIsAllowed(), "copy:", this.file.PID.copy, "readonly", this.file.readOnly, "locked", this.file.locked);

          //console.log("get file with version", this.originPIDId, this.file.PID._id, this.versionId, "file", this.file);
          if (this.versionId) {
            var f = this._fileService.getFileVersionURL(this.file.sharingType == 'distinct' ? this.originPIDId : this.file.PID._id, this.file, this.versionId);
          } else {
            var f = this._fileService.getFileURL(this.file.sharingType == 'distinct' ? this.originPIDId : this.file.PID._id, this.file);
          }

          f.subscribe(
            (ret: any) => {
              if (ret.version) {
                //console.log("load file file.version 0", file.version, ret.version, ret.fullVersions);
                if (ret.fullVersions) {
                  //this.file.versions = ret.fullVersions.sort((a, b) => moment(b.date).isAfter(a.date));
                  this.file.versions = ret.fullVersions.sort((a, b) => moment(b.date).diff(moment(a.date)));
                  this.file.allVersions = this.file.versions;
                } else {
                  this.file.versions = file.version.sort((a, b) => moment(b.date).diff(moment(a.date)));
                  this.file.allVersions = this.file.versions;
                }
                //console.log("load file file.version 1", this.file.versions, this.file.versions[0].date, moment(this.file.versions[0].date).format('YYYYMMDD HH:mm:ss'));

                // user has not selected a specific version, take the most recent
                if (!this.versionId && this.file.allVersions.length) {
                  this.versionId = this.file.allVersions[0]._id;
                }

                this.file.versions = this._fileService.displayVersionsOnly(this.file.versions);

                //console.log("all versions", this.file.allVersions);
                //console.log("versions", this.file.versions);

                this.file['version'] = ret.version;
                //console.log("ret version files", ret, this.file.allVersions);

                this.fileViewUrls = _.map(ret.version.files, (f, i) => {
                  let unconvertedVersion = this.getUnconvertedVersion(this.versionId);
                  //console.log("unconverted", i, f, "versionId", this.versionId, "unconverted", unconvertedVersion);
                  let r = {
                    type: f['fileType'],
                    name: unconvertedVersion ? unconvertedVersion.files[i].name : f['name'],
                    metaType: this.file['type'],
                    description: this.file['description'],
                    contractor: this.file['contractor'],
                    deadline: this.file['deadline'],
                    room: this.file['room'],
                    version: this.file['version'],
                    originalGetUrl: ret.urls[i],
                    url: ret.urls[i],
                    downloadUrl: this._sanitizer.bypassSecurityTrustUrl(ret.urls[i])
                  }
                  return r;
                });

                //console.log(this.fileViewUrls);
                this.galleryImages = this.fileViewUrls.filter(x=>x.type && x.type.startsWith('image')).map(x => { return {'small': x.url, 'medium': x.url, 'big': x.url, 'description' : x.name}});
                this.fileViewUrls = this.fileViewUrls.filter(x=>!(x.type && x.type.startsWith('image')));
                this.paginate = pagix({ records: this.galleryImages.length, limit: 16, delta: 3 });
                //console.log(this.paginate);

                //console.log(this.galleryImages);
              } /*else {
                //
                this.file.versions = [];
              }*/

              if (this.fileViewUrls && this.fileViewUrls.length > 0) {
                this.fileDetails = this.fileViewUrls;
                this.fileDetails[0].PID = this.file.PID;
                this.fileDetails[0].sharing = this.file['sharing'];
                this.fileDetails[0].sharingType = this.file['sharingType'];
                this.fileDetails[0].status = this.getStatus(this.file);

                //console.log("this.filedetails 1", this.fileViewUrls);
              } else {
                this.fileDetails = [{
                  type: file['fileType'],
                  name: file['name'],
                  metaType: this.file['type'],
                  description: this.file['description'],
                  contractor: this.file['contractor'],
                  deadline: this.file['deadline'],
                  room: this.file['room'],
                  sharing: this.file['sharing'],
                  sharingType: this.file['sharingType'],
                  version: this.file['version'],
                  status: this.getStatus(this.file)
                }];
                //console.log("this.filedetails 2", this.fileViewUrls);
              }

            },
            err => {
              this.error = "MESSAGE.ERROR.FILE_NOT_FOUND";
              this._notification.errorServer(err);
            }
          );

          this._fileService.getFileLinkStats(this.file._id)
            .subscribe(
              ret => {
                this.fileLinkStats = ret;
              },
              err => {
                this.error = "MESSAGE.ERROR.FILE_NOT_FOUND";
                this._notification.errorServer(err);
              }
            );

          this._messageService.getOwnerFileMessages(this.file['_id']).subscribe(
            messages => {
              this.messages = _.map(messages, m => { return this._setMessageDisplayInfo(m); });
              if (this.messages.length > 0) {
                this.openMessages = true;
              }
            },
            err => { }
          );
        },
        err => this.error = "MESSAGE.ERROR.FILE_NOT_FOUND"
      );

  }

  getUnconvertedVersion(versionId) {
    let versionInfo = this.file.allVersions.filter(x => x._id == versionId);
    if (versionInfo && versionInfo.length && versionInfo[0].converted) {
      return this.file.allVersions[this.file.allVersions.map(x => x._id).indexOf(versionId) + 1];
    } else {
      return this.file.allVersions[this.file.allVersions.map(x => x._id).indexOf(versionId)];;
    }
  }

  getOriginalFile() {
    if (!this.file['version'] || !this.file['version'].date) { return; }

    let versionToGet = this.getUnconvertedVersion(this.versionId)._id;

    //console.log("getOriginalFile", this.versionId, this.file.allVersions, this.file.allVersions.filter(x => x._id == this.versionId), versionToGet);

    this._fileService.getOriginalFileVersion(this.file.PID._id, this.file, versionToGet)
      .subscribe(
        (ret: any) => {
          _.forEach(ret.version.files, (file, i) => {
            var a = document.createElement('a');
            a.href = ret.urls[i];
            a.target = '_self';
            a.download = file.name;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          });
        },
        err => this._notification.errorServer(err)
      );
  }

  getStatus = (row) => this._filetable.getStatus(row, this.parentPID());
  status2imgfn = (status) => this._filetable.status2imgfn(status);
  room2imgfn = (room) => this._filetable.room2imgfn(room);
  contractorClass = (row) => this._filetable.contractorClass(row);
  formatContractor = (row) => this._filetable.formatContractor(row);

  getMessagePadding() {
    return this.openMessages ? '24px 24px 0 24px' : '0px';
  }

  getMessageWidth() {
    return this.openMessages ? '350px' : '100%';
  }

  ngOnInit() {
    this.isPhone = window.matchMedia('(max-width: 767px)').matches;


    this.galleryOptions = [
      {
        width: '100%',
        height: '600px',
        thumbnailsColumns: 8,
        thumbnailsRows: 2,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewCloseOnClick: true,
        previewCloseOnEsc: true,
        previewKeyboardNavigation: true,
        thumbnailsRemainingCount: false,
        imageDescription: true,
        thumbnailsMoveSize: 16,
        previewDownload: true
      },
      // max-width 800
      {
        breakpoint: 980,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false
      }
    ];

  }

  private _setMessageDisplayInfo(message) {
    var date = new Date(message.updatedAt);
    message.content = message.content.split('\n').join('<br>');
    message.author = (message.from == this.file.PID.PIDOwner.email) ? 'DATA.YOU' : this.file['contractor'].name;
    message.side = (message.from == this.file.PID.PIDOwner.email) ? 'right' : 'left';
    message.updatedAt = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
    return message;
  }

  galleryChange(c){
    console.log("gallery change", c);
  }

  galleryPreviewClose(c){
    console.log("gallery close", c);
    this.selectedIndex = this.previewIndex || this.selectedIndex;
  }

  galleryPreviewChange(e){
    console.log("gallery change", e);
    this.previewIndex = e.index;
  }

  galleryPage(p){
    this.gallery.show((p-1)*16);
    this.paginate = pagix({ records: this.galleryImages.length, limit: 16, delta: 3, current: p });
    //console.log(this.paginate.start.slice(-1), this.paginate.middle.slice(0,1), this.paginate.middle.slice(-1), this.paginate.end.slice(0,1));
  }

  sendMessage(content) {
    this._messageService.addOwnerMessage(this.file['_id'], content)
      .subscribe(message => {
        this.messages.push(this._setMessageDisplayInfo(message));
      });
  }

  currentVersion() {
    if (!this.file.versions) {
      return !this.versionId;
    }

    let res = !this.versionId || (this.versionId == this.file.allVersions[0]._id);
    //console.log("currentVersion", res, this.file.allVersions);
    return res;
  }

  editCompleted(file) {
    //console.log("edit or upload completed", this.file._id, this.originPIDId);
    this.modal.editFile = false;
    this.ngAfterViewInit();
    return;
  }

  lock() {
    this._fileService.lock(this.file['_id']).subscribe(f => {
      this.file['locked'] = true;
    });
  }

  unlock() {
    this._fileService.unlock(this.file['_id']).subscribe(f => {
      this.file['locked'] = false;
    });
  }

  unlink(fl) {
    this._fileService.unlink(fl._id).subscribe(f => {
      fl.deleted = true;
    });
  }

  deleteFileVersion(file, version) {
    this.modal.deleteFile = true;
    this.modal.file = file;
    this.modal.version = version;
  }

  confirmDeleteFileVersion(file, version) {
    this.modal.file = null;
    this.modal.version = null;
    this.modal.deleteFile = false;

    //console.log("delete file version", file, version, file._id, version._id, this.originPIDId);
    this._fileService.deleteFileVersion(this.originPIDId, file._id, version._id).subscribe(f => {
      //f.deleted = true;
      //console.log("delete version done");
      this.fileViewUrls = [];
      this.file.versions = [];
      this.ngAfterViewInit();
      this._router.navigate(['file', this.file._id, this.originPIDId]);
      return;
    });
  }

  deleteFile(f) {
    this.modal.deleteFile = true;
  }

  parentPID() {
    return this.originPIDId || this.file.PID._id;
  }

  confirmDeleteFile() {
    this.modal.deleteFile = false;

    this._fileService.deleteFile(this.parentPID(), this.file._id)
      .subscribe(
        () => {
          this._router.navigate(['pid', this.parentPID()]);
        },
        this._notification.errorServer
      );
  }

  initLinkFile() {
    if (this.linkEmail) {
      this._fileService.initLink(this.file.PID._id, this.file['_id'], this.linkEmail, this.originPIDId).subscribe(
        ret => {
          this.modal.linkFile = false;
          this._notification.info('MESSAGE.LINK_INITIATED');
        },
        this._notification.errorServer
      );
    }
  }

  fileIsFullyEditable() {

    // shared distinct is not editable from subpid
    if (this.file.sharingType == 'distinct' && this.originPIDId != this.file.PID._id) {
      //if (this.originPIDId && this.file.PID && this.file.PID._id) {
      //console.log("editable", this.file.PID._id, this.originPIDId, "copy", this.file.PID.copy, "ro", this.file.readOnly, "locked", this.file.locked);
      return false;
    }

    return true;
  }

  userIsAllowed() {
    return !this._user.expired() && !this.file.PID.expired;
  }

  rootPIDFile() {
    return this.file && this.file.PID && this.originPIDId == this.file.PID._id;
  }

  canEdit() {
    //console.log("can edit", this.originPIDId, this.file.PID._id, this.file.sharingType);
    if (this.originPIDId != this.file.PID._id) {
      if (this.file.sharingType == 'distinct') {
        return true;
      }
      return false;
    }
    if (this.file.readOnly){
      return false;
    }
    return true;
  }

  goToAudittrail(){
    this._router.navigate(['audittrail', 'file', this.file._id]);
  }

  canDeleteVersion() {
    return !this.file.readOnly && !this.file.PID.copy && ((this.rootPIDFile() && this.file.sharingType == 'shared') || (!this.rootPIDFile() && this.file.sharingType == 'distinct'));
  }

  editOnProject() {
    this._router.navigate(['file', this.file._id, this.file.PID._id]);
  }

  formatLinkContractor(c) {
    return c.name + ' (' + c.email + ')';
  }

  contractorAutocompleteFilter(list, val: string) {
    return list.filter(option => ((option.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
      (option.email.toLowerCase().indexOf(val.toLowerCase()) > -1)));
  }

  showDotsPaginateMiddle(paginate){
    //console.log("paginate start / end middle", paginate, paginate.start, paginate.end);
    return paginate.middle.length && paginate.start.slice(-1)[0]+1 != paginate.middle.slice(0,1) && paginate.start.slice(-1)[0]+1 != paginate.end.slice(0, 1);
  }

  showDotsPaginateEnd(paginate){
    //console.log("paginate start / end end", paginate, paginate.start, paginate.end);
    return paginate.end.length && paginate.start.slice(-1)[0]+1 != paginate.end.slice(0,1);
  }

}
